import React from "react";
import "./Process.css";
import { FaCommentDots, FaClipboardList, FaCogs, FaCheckDouble } from "react-icons/fa";
import useInView from "../hooks/useInView";

const STEPS = [
  {
    n: "01",
    Icon: FaCommentDots,
    title: "Discovery Call",
    desc: "Share your goals and requirements. We listen carefully and ask the right questions to scope your project accurately.",
  },
  {
    n: "02",
    Icon: FaClipboardList,
    title: "Proposal & Plan",
    desc: "You receive a detailed quote with timelines, deliverables, and pricing — clear, transparent, no surprises.",
  },
  {
    n: "03",
    Icon: FaCogs,
    title: "Execution",
    desc: "Our specialists get to work. You get regular progress updates and a single point of contact throughout.",
  },
  {
    n: "04",
    Icon: FaCheckDouble,
    title: "Review & Deliver",
    desc: "Final QA, your feedback, revisions if needed, then on-time delivery — built to stand up to real-world use.",
  },
];

const Process = () => {
  const [headRef, headInView] = useInView();
  const [gridRef, gridInView] = useInView();

  return (
    <section className="process-section">
      <span className="process-orb orb-a" />
      <span className="process-orb orb-b" />

      <div className="process-container">
        <div ref={headRef} className={`process-head ${headInView ? "in-view" : ""}`}>
          <span className="section-eyebrow">How We Work</span>
          <h2>
            From first call to final delivery —{" "}
            <span className="gradient-text">a process that works</span>
          </h2>
          <p>
            Every project follows the same proven path. No mysterious black
            box, no shifting timelines.
          </p>
        </div>

        <div ref={gridRef} className={`process-grid ${gridInView ? "in-view" : ""}`}>
          {/* Animated connecting line */}
          <div className="process-line" />
          <div className="process-line-fill" />

          {STEPS.map(({ n, Icon, title, desc }, i) => (
            <div
              key={n}
              className="process-step"
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              <div className="step-number">{n}</div>
              <div className="step-card">
                <div className="step-icon">
                  <Icon />
                </div>
                <h3>{title}</h3>
                <p>{desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
